import React, { Component } from "react";
import { FaInstagram, FaFacebookF, FaLine } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import { FiX, FiMenu } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// const SocialShare = [
//     { Social: <FaFacebookF />, link: 'https://www.facebook.com/farmchansawangyasothon' },
//     { Social: <FaInstagram />, link: 'https://www.instagram.com/farmchansawangyasothon' },
//     { Social: <SiTiktok  />, link: 'https://www.tiktok.com/@farmchansawangyasothon' },
//     { Social: <FaLine  />, link: 'https://lin.ee/htkgF3M' },
// ]
class Header extends Component {
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);

        //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function () {
            console.log('All assets are loaded');
        })

    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }

    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open')
    }

    stickyHeader() { }
    render() {
        window.addEventListener('scroll', function () {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            } else {
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });
        var elements = document.querySelectorAll('.has-droupdown > a');
        for (var i in elements) {
            if (elements.hasOwnProperty(i)) {
                elements[i].onclick = function () {
                    this.parentElement.querySelector('.submenudesktop').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const { logo, color = 'default-color', t } = this.props;
        const logoAlt = t('common.logoAlt');
        let logoUrl;
        if (logo === 'light') {
            logoUrl = <img className="logo-circle" src="/assets/images/logo/logo.png" alt={logoAlt} />;
        } else {
            logoUrl = <img className="logo-circle" src="/assets/images/logo/logo.png" alt={logoAlt} />;
        }

        return (
            <header className={`header-area header--fixed ${color}`}>
                <div className="header-wrapper">
                    <div className="header-left d-flex align-items-center">
                        <div className="logo">
                            <a href="/">{logoUrl}
                            </a>
                            {/* <a href={this.props.homeLink}>
                                {logoUrl}
                            </a> */}
                        </div>
                        <nav className="mainmenunav d-lg-block ml--50">
                            <ul className="mainmenu">
                                <li className="mobile-contact mb--30 mt--10">
                                    <a href="/">
                                        <img className="w-100 logo-circle" src="/assets/images/logo/logo.png" alt={logoAlt} />
                                    </a>
                                </li>
                                <li><Link to="/" >{t('nav.home')}</Link></li>

                                {/* Desktop */}
                             

                                {/* MOBILE */}
                                <li className="has-droupdown mobile-show">
                                    <Link to="/" >{t('nav.gallery')}</Link>
                                </li>

                                <li><Link to="/media" >{t('nav.media')}</Link>
                                </li>
                                <li><Link to="/education" >{t('nav.education')}</Link>
                                </li>
                                <li><Link to="/reward" >{t('nav.reward')}</Link>
                                </li>
                                <li><Link to="/past-activities" >{t('nav.pastActivities')}</Link>
                                </li>
                                <li><Link to="/contract" >{t('nav.contract')}</Link>
                                </li>
                                <li><Link to="/about" >{t('nav.about')}</Link>
                                </li>


                                <li className="mobile-contact mt--30 d-flex d-md-none justify-content-center">
                                    <div className="language-switcher">
                                        <button type="button" className={this.props.i18n.language === 'th' ? 'active' : ''} onClick={() => this.props.i18n.changeLanguage('th')}>TH</button>
                                        <span className="mx--10">|</span>
                                        <button type="button" className={this.props.i18n.language === 'en' ? 'active' : ''} onClick={() => this.props.i18n.changeLanguage('en')}>EN</button>
                                    </div>
                                </li>
                                <li className="mobile-contact mt--50">
                                    <div>
                                        <div className="social-share-inner">
                                            <ul className="social-share-herder color-black d-flex justify-content-center liststyle">

                                                <li className="facebook"><a href="https://www.facebook.com/farmchansawangyasothon" aria-label="facebook"><FaFacebookF /></a></li>
                                                <li className="instagram"><a href="https://www.instagram.com/farmchansawangyasothon" aria-label="instagram"><FaInstagram /></a></li>
                                                <li className="tiktok"><a href="https://www.tiktok.com/@farmchansawangyasothon" aria-label="tiktok"><SiTiktok /></a></li>
                                                <li className="line"><a href="https://lin.ee/htkgF3M" aria-label="line"><FaLine /></a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </li>

                            </ul>



                        </nav>
                    </div>
                    <div className="header-right">
                        <div className="social-share-inner d-none d-sm-block ml--50">
                            <ul className="social-share-herder color-black d-flex justify-content-start liststyle">

                                <li className="facebook"><a href="https://www.facebook.com/farmchansawangyasothon" aria-label="facebook"><FaFacebookF /></a></li>
                                <li className="instagram"><a href="https://www.instagram.com/farmchansawangyasothon" aria-label="instagram"><FaInstagram /></a></li>
                                <li className="tiktok"><a href="https://www.tiktok.com/@farmchansawangyasothon" aria-label="tiktok"><SiTiktok /></a></li>
                                <li className="line"><a href="https://lin.ee/htkgF3M" aria-label="line"><FaLine /></a></li>

                            </ul>
                        </div>
                        {/* <div className="header-btn">
                            <a className="btn-default btn-border btn-opacity" target="_blank" href="https://themeforest.net/checkout/from_item/31405042?license=regular">
                                <span>buy Now</span>
                            </a>
                        </div> */}
                        <div className="language-switcher d-none d-md-flex align-items-center mr--20">
                            <button type="button" className={this.props.i18n.language === 'th' ? 'active' : ''} onClick={() => this.props.i18n.changeLanguage('th')} aria-label="ไทย">TH</button>
                            <span className="mx--10 text-muted">|</span>
                            <button type="button" className={this.props.i18n.language === 'en' ? 'active' : ''} onClick={() => this.props.i18n.changeLanguage('en')} aria-label="English">EN</button>
                        </div>
                        <div className="humberger-menu d-block d-lg-none pl--20 pl_sm--10">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default withTranslation()(Header);
